var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourceCenterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10V12.78C22 16.34 21.11 17.22 17.56 17.22H6.44C2.89 17.22 2 16.33 2 12.78V6.44C2 2.89 2.89 2 6.44 2H12",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.22V22",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H22",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22H16.5",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 4.5,
    r: 4.1,
    stroke: "#7D899D",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7637 5.57861H18.0015C18.0037 5.3667 18.022 5.18896 18.0562 5.04541C18.0903 4.89958 18.1473 4.76742 18.2271 4.64893C18.3091 4.53044 18.4173 4.40511 18.5518 4.27295C18.6566 4.17269 18.7511 4.07812 18.8354 3.98926C18.9198 3.89811 18.987 3.80241 19.0371 3.70215C19.0872 3.59961 19.1123 3.48226 19.1123 3.3501C19.1123 3.20654 19.0884 3.08464 19.0405 2.98438C18.9927 2.88411 18.922 2.80778 18.8286 2.75537C18.7375 2.70296 18.6235 2.67676 18.4868 2.67676C18.3729 2.67676 18.2658 2.69954 18.1655 2.74512C18.0653 2.78841 17.9844 2.85677 17.9229 2.9502C17.8613 3.04134 17.8283 3.16211 17.8237 3.3125H17C17.0046 3.02539 17.0729 2.78385 17.2051 2.58789C17.3372 2.39193 17.515 2.24495 17.7383 2.14697C17.9616 2.04899 18.2111 2 18.4868 2C18.7922 2 19.0531 2.05241 19.2695 2.15723C19.486 2.25977 19.6512 2.41016 19.7651 2.6084C19.8813 2.80436 19.9395 3.04134 19.9395 3.31934C19.9395 3.51986 19.8996 3.70215 19.8198 3.86621C19.7401 4.02799 19.6364 4.17952 19.5088 4.3208C19.3812 4.4598 19.2433 4.5988 19.0952 4.73779C18.9676 4.854 18.881 4.98047 18.8354 5.11719C18.7899 5.25163 18.766 5.40544 18.7637 5.57861ZM17.9331 6.64502C17.9331 6.52197 17.9753 6.41829 18.0596 6.33398C18.1439 6.2474 18.259 6.2041 18.4048 6.2041C18.5506 6.2041 18.6657 6.2474 18.75 6.33398C18.8343 6.41829 18.8765 6.52197 18.8765 6.64502C18.8765 6.76807 18.8343 6.87288 18.75 6.95947C18.6657 7.04378 18.5506 7.08594 18.4048 7.08594C18.259 7.08594 18.1439 7.04378 18.0596 6.95947C17.9753 6.87288 17.9331 6.76807 17.9331 6.64502Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceCenterIcon);
export default __webpack_public_path__ + "static/media/resource-center-icon.310a2d1cc6b46409707729f90605c62e.svg";
export { ForwardRef as ReactComponent };